// Rotulos em pt-BR dos tipos de `movimentacoes_estoque`, pra aba Movimentacoes da ficha ([DA-656]).
//
// ⛔ O mapa FALHA ABERTO de proposito: tipo que nao estiver aqui aparece com o proprio codigo, nunca
// some da lista nem vira "Outro". A tabela tinha 25 combinacoes de tipo/origem no dia em que isto
// nasceu e ganha uma a cada recurso novo de estoque — lista fechada esconderia justamente o
// movimento inedito, que e o que alguem estaria procurando.

const NOMES: Record<string, string> = {
  venda_saida: 'Venda',
  venda_estorno: 'Venda cancelada',
  ajuste_manual: 'Ajuste manual',
  transferencia_lugar: 'Transferência de prateleira',
  entrada_nota: 'Entrada por nota',
  entrada_nota_estorno: 'Entrada de nota estornada',
  contagem_prateleira: 'Contagem de prateleira',
  estoque_inicial: 'Estoque inicial',
  fracionamento_entrada: 'Fracionamento (entrada)',
  fracionamento_saida: 'Fracionamento (saída)',
  fracionamento_auto_entrada: 'Fracionamento automático (entrada)',
  fracionamento_auto_saida: 'Fracionamento automático (saída)',
  devolucao_nfe: 'Devolução do cliente',
  devolucao_compra: 'Devolução ao fornecedor',
  devolucao_compra_cancelada: 'Devolução ao fornecedor cancelada',
  troca_entrada: 'Troca (entrada)',
  entrada_troca: 'Troca (entrada)',
  saida_troca: 'Troca (saída)',
  cancel_troca: 'Troca cancelada',
  venda_cm_saida: 'Venda CM (consignação)',
  venda_cm_devolucao: 'Devolução de venda CM',
  remessa_consignacao: 'Remessa de consignação',
  retorno_consignacao: 'Retorno de consignação',
};

export function rotuloMovimentacao(tipo: string): string {
  return NOMES[tipo] ?? tipo;
}

export type SentidoMovimentacao = 'entrada' | 'saida' | 'lateral';

// ⚠️ O sentido sai do SALDO, nunca do nome do tipo nem do sinal da quantidade sozinho.
// `transferencia_lugar` grava quantidade POSITIVA (9) com o total parado (17 -> 17): ela troca a
// mercadoria de prateleira e nao poe nada na loja. Lida pelo sinal, a tela diria "+9" ao lado das
// vendas e afirmaria uma entrada que nunca existiu. Medido em 01/09/2026 nos 173 registros do tipo.
export function sentidoMovimentacao(
  estoqueAntes: string | number | null,
  estoqueDepois: string | number | null,
): SentidoMovimentacao {
  if (estoqueAntes === null || estoqueDepois === null) return 'lateral';
  const antes = Number(estoqueAntes);
  const depois = Number(estoqueDepois);
  if (!Number.isFinite(antes) || !Number.isFinite(depois)) return 'lateral';
  if (depois > antes) return 'entrada';
  if (depois < antes) return 'saida';
  return 'lateral';
}
